import { render, staticRenderFns } from "./regionsmanager-filter-button-group.vue?vue&type=template&id=6af9bbf2"
import script from "./regionsmanager-filter-button-group.vue?vue&type=script&lang=js"
export * from "./regionsmanager-filter-button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports